import assets from '../../apis/assets.api';
export const getSensors = (params) => {
    return assets.get('/assets', { params });
};
export const deleteAsset = (assetId) => {
    return assets.post('/assets/bulk', [
        {
            operation: 'delete',
            data: { body: { _id: assetId } },
        },
    ]);
};
